import Itemhunter from './Itemhunter';

// 블소 오픈 시간
// const START_DATE_BNS = '2023-07-26T12:10:00+09:00';
// const END_DATE_BNS = '2023-08-02T12:00:00+09:00';

// 아이온 오픈 시간
// const START_DATE_AION = '2023-07-26T12:10:00+09:00';
// const END_DATE_AION = '2023-08-02T12:00:00+09:00';

// const START_DATE_L1 = '2023-08-09T14:00:00+09:00';
// const END_DATE_L1 = '2023-08-16T13:00:00+09:00';

// const START_DATE_L2 = '2023-08-09T13:00:00+09:00';
// const END_DATE_L2 = '2023-08-16T13:00:00+09:00';





// ********************************* [TODO] 날짜 확인!!!!!!!!
// 라이브 전에 날짜 확인!!!!!!!!!!!! ***************************
const START_DATE = '2024-10-30T09:59:00+09:00';
const END_DATE = '2024-11-06T04:30:00+09:00';
// *******************************************************
// *******************************************************






window.promoItemhunter = ({minSec = 1, maxSec = 5, zIndex=9100006, isLogin = false, iconId, apidomain, eventCode }:{minSec?:number, maxSec?:number, zIndex?:number, isLogin?: boolean, iconId: string , apidomain: string, eventCode:string}) => {
  // return false; // 라이브 전
  if(!window.userData?.now){
    console.error('userDate.now 가 없습니다?');
  }

  const nowDateUtcStr = window.userData?.now || new Date(); // '2022-08-11T03:53:54.542731Z'
  const nowDateTime = new Date(nowDateUtcStr).getTime();

  let startDateTime;
  let endDateTime;

  // if(eventCode == 'bns-20230726'){
  //   startDateTime = new Date(START_DATE_BNS).getTime();
  //   endDateTime = new Date(END_DATE_BNS).getTime();
  // }else if(eventCode == 'aion-20230726'){
  //   startDateTime = new Date(START_DATE_AION).getTime();
  //   endDateTime = new Date(END_DATE_AION).getTime();
  // }else if(eventCode == 'lin-20230809'){
  //   startDateTime = new Date(START_DATE_L1).getTime();
  //   endDateTime = new Date(END_DATE_L1).getTime();
  // }else if(eventCode == 'lin2-20230809'){
  //   startDateTime = new Date(START_DATE_L2).getTime();
  //   endDateTime = new Date(END_DATE_L2).getTime();
  // }

  startDateTime = new Date(START_DATE).getTime();
  endDateTime = new Date(END_DATE).getTime();

  // 시작 전
  if(!startDateTime || nowDateTime < startDateTime){
    console.log('아이템 시작전!');
    return false;
  }
  // 종료 후
  if(!endDateTime || nowDateTime > endDateTime){
    console.log('아이템 사냥꾼 종료!');
    return false;
  }

  const itemHunter = new Itemhunter(({minSec, maxSec, zIndex, isLogin, iconId, apidomain, eventCode}));
  itemHunter.init();

};


/** 바닦에서 직접 실행 */

/*
document.addEventListener('DOMContentLoaded', function() {
  new window.promoItemhunter({
      apidomain: "[[ ${ui['domain.plaync']} ]]",
      eventCode: 'linw-20240731',
      isLogin: [[ ${isLogin} ]]
  })
});
*/
